import { createFileRoute } from "@tanstack/react-router"
import { GroupDetailPage } from "@/components/rema/groups"

function GroupDetailRoute() {
  const { groupNumber } = Route.useParams()
  return (
    <div className="p-6">
      <GroupDetailPage groupNumber={groupNumber} />
    </div>
  )
}

export const Route = createFileRoute("/rema/groups/$groupNumber")({
  staticData: {
    title: 'Group Detail',
    isSecured: true,
  },
  component: GroupDetailRoute,
})
